import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { UserLoginPageRoutingModule } from "./user-login-routing.module";
import { UserLoginPage } from "./user-login/user-login.page";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { MaterialModule } from "src/app/material-file/material.module";
import { LoginService } from "src/app/services/login.service";
import { AgentSignupComponent } from "./agent-signup/agent-signup.component";
import { FileUploadModule } from "ng2-file-upload";
import { SharedModuleModule } from 'src/app/shared-module/shared-module.module';
import { NgOtpInputModule } from 'ng-otp-input';
import { MatChipsModule } from "@angular/material/chips";
import { IonicModule } from "@ionic/angular";

@NgModule({
  declarations: [
    UserLoginPage,
    AgentSignupComponent,
    // LoginOTPComponent,

    // LogInOTPVerificationDialog,
  ],
  imports: [
    CommonModule,
    UserLoginPageRoutingModule,
    MatChipsModule,
    NgOtpInputModule,
    ReactiveFormsModule,
    FormsModule,
    MaterialModule,
    FileUploadModule,
    SharedModuleModule,
    IonicModule
], exports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [LoginService],
})
export class LoginModule { }
